<template>
    <b-modal
        v-model="newImageModal"
        size="xl"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        >
        <template v-slot:modal-title>
            <div class="pb-2">Agregar imagen al cliente web</div>
        </template>
        <b-row>
            <b-col cols="12">
                <p class="font-weight-medium">Por favor ingrese los datos de la imagen para registrarla.</p>
            </b-col>
            <b-col cols="12" md="6">
                <label>Sección de la imagen:</label>
                <b-form-select 
                    v-model="imageData.sectionOption" 
                    value-field="value" 
                    text-field="name" 
                    :options="optionsImage">
                    <template #first>
                        <b-form-select-option value="">-- Seleccione una opción --</b-form-select-option>
                    </template>
                </b-form-select>
                <span class="priority-description">{{ selectedOptionDescription }}</span>
            </b-col>
            <b-col cols="12" md="6">
                <label>Prioridad de la imagen:</label>
                <b-form-select class="select-size" v-model="imageData.orderOption" :options="options"></b-form-select>
                <span class="priority-description">El 0 es la prioridad más alta, y el 5 es la más baja.</span>
            </b-col>
            <b-col cols="12" md="6">
                <label>Image:</label>
                <b-form-file
                    v-model="selectedImage"
                    @change="handleImageChange"
                    placeholder="Selecciona una imagen..."
                    drop-placeholder="Arrastra una imagen aqui..."
                    accept="image/*"
                ></b-form-file>
                <img class="thumbnail pt-2" :src="previewImage" v-if="previewImage" alt="Vista previa de la imagen">

            </b-col>
            <b-col cols="12">
                <b-alert show variant="danger" v-if="imageFormValidateError.length > 0">
                    <ul>
                        <li v-for="(item, index) in imageFormValidateError" :key="index">{{ item }}</li>
                    </ul>
                </b-alert>
            </b-col>
        </b-row>
        <template v-slot:modal-footer>
            <b-button variant="danger" @click.prevent="$emit('close-modal', false)">
                Cancelar
            </b-button>
            <b-button variant="info" @click.prevent="submitImage()">
                Procesar
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import {  mapMutations } from 'vuex'
export default {
    name: "ImageFormModal",
    props: {
        newImageModal: {
            type: Boolean
        },
        imageData: {
            type: Object
        },
        optionsImage: {
            type: Array
        }
    },
    data() {
        return {
            options: this.orderOptions(),
            selectedImage: null,
            previewImage: null,
            imageFormValidateError: []
        };
    },
    computed: {
        selectedOptionDescription() {
            const selectedOption = this.optionsImage.find((option) => option.value === this.imageData.sectionOption);
            return selectedOption ? selectedOption.description : '';
        },
    },
    methods: {
        ...mapMutations(['setLoading']),
        orderOptions() {
            return Array.from(Array(6).keys());
        },
        handleImageChange(event) {
            const file = event.target.files[0];
            if (file && file.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onload = () => {
                this.previewImage = reader.result;
            };
            reader.readAsDataURL(file);
            }
        },
        async submitImage() {
            this.imageFormValidateError = [];
            this.setLoading(true)
            let formData = new FormData();
            formData.append('image', this.selectedImage);
            formData.append('sectionOption', this.imageData.sectionOption);
            formData.append('orderOption', this.imageData.orderOption);

            await this.$conectar.post('configuration/client-web/store-image-data', formData)
            .then(response =>{
                if(response.data.errors){
                    this.imageFormValidateError = Object.values(response.data.errors).flat();
                }else if(response.data.error === false){
                    this.$emit('image-saved');
                }
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        }
    }
};

</script>
<style scoped>

.priority-description{
    font-size: 13px;
    color:brown;
}

.thumbnail {
  width: 250px;
  height: 250px;
  margin-right: 10px;
}

</style>